import { MENU_INTERNAL, MENU_EXTERNAL } from 'components/menu';
import { Glambox } from 'components/icons/Glambox';
import { Subscription } from 'components/icons/Subscription';
import { UserIcon } from 'components/icons/UserIcon';
import { Beauty } from 'components/icons/Beauty';
import { GlamClub } from 'components/icons/GlamClub';
import { GlamgirlFlat } from 'components/icons/GlamgirlFlat';
import { GlamgirlLine } from 'components/icons/GlamgirlLine';
import { About } from 'components/icons/About';
import { HashtagIcon } from 'components/icons/Hashtag';
import { Points } from 'components/icons/Points';
import { Feedback } from 'components/icons/Feedback';
import { Events } from 'components/icons/Events';
import { Influencer } from 'components/icons/Influencer';
import { OnlineCourse } from 'components/icons/OnlineCourse';
import { Mag } from 'components/icons/Mag';
import { CartIcon } from 'components/icons/CartIcon';
import { HandshakeIcon } from 'components/icons/HandshakeIcon';
import { Logout } from 'components/icons/Logout';
import { Bag } from 'components/icons/Bag';
import { Star } from 'components/icons/Star';

const Community = {
  active: {
    label: 'Comunidade',
    path: '/chama-as-amigas',
    type: MENU_INTERNAL,
    active: true,
    children: [
      {
        label: 'Chama as Amigas',
        path: '/chama-as-amigas',
        icon: Feedback,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Eventos',
        path: '/eventos',
        icon: Events,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Programa de Influenciadores',
        path: '//glampartners.com.br',
        icon: Influencer,
        type: MENU_EXTERNAL,
        children: null,
        active: true,
      },
    ],
  },
  partner: {
    label: 'Comunidade',
    icon: null,
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Programa de Influenciadores',
        path: '//glampartners.com.br',
        icon: Influencer,
        type: MENU_EXTERNAL,
        children: null,
        active: true,
      },
    ],

    active: true,
  },
};

const ExclusiveContents = {
  active: {
    path: '/conteudo-exclusivo',
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Cursos Online',
        path: '/cursos-online',
        icon: OnlineCourse,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'MAG',
        path: '//glambox.com.br/mag',
        icon: Mag,
        type: MENU_EXTERNAL,
        children: null,
        active: true,
      },
    ],
    active: true,
  },
  inactive: {
    path: '//glambox.com.br/mag',
    type: MENU_EXTERNAL,
    children: null,
    active: true,
  },
};

const MenuBase = [
  {
    label: 'Minha Glambox',
    path: '/',
    icon: null,
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Home',
        path: '/',
        icon: Glambox,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Edições',
        path: '/edicoes',
        icon: Subscription,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Dados Pessoais',
        path: '/dados-pessoais',
        icon: UserIcon,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Perfil de Beleza',
        path: '/perfil-de-beleza',
        icon: Beauty,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Histórico de Pagamentos',
        path: '/assinatura',
        icon: Subscription,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
    ],
    active: true,
  },
  {
    label: 'GlamClub',
    path: '/produtos',
    icon: null,
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Vitrine',
        path: '/produtos',
        icon: GlamClub,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Como Funciona',
        path: '/sobre-o-glamclub',
        icon: About,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Campanhas #Hashtag',
        path: '/ganhe-mais-glampoints',
        icon: HashtagIcon,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Glampoints',
        path: '/glampoints',
        icon: Points,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
    ],
    active: true,
  },
  {
    label: 'Comunidade',
    path: '/comunidade',
    icon: null,
    type: MENU_INTERNAL,
    children: null,
    active: false,
  },
  {
    label: 'Conteúdo Exclusivo',
    path: '/conteudo-exclusivo',
    icon: null,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'Glamshop',
    path: '//glamshop.com.br',
    icon: null,
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Visitar Glamshop',
        path: '//glamshop.com.br/',
        icon: Glambox,
        type: MENU_EXTERNAL,
        children: null,
        active: true,
        // custom: "teste"
      },
      {
        label: 'Glamgirl no Glamshop',
        path: '//glamshop.com.br/collections/marca-glamgirl',
        icon: GlamgirlLine,
        type: MENU_EXTERNAL,
        children: null,
        active: true,
      },
    ],
    active: true,
  },
  {
    label: 'Portal Glampartners',
    path: '/glampartner',
    icon: null,
    type: MENU_EXTERNAL,
    children: null,
    active: false,
  },
  {
    label: 'Logout',
    path: '/logout',
    icon: null,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
];

const MenuNonSubscriber = [
  {
    label: 'Benefícios',
    path: '/beneficios',
    icon: Glambox,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'Mágica do Cookie',
    path: '/magica-do-cookie',
    icon: Glambox,
    type: MENU_INTERNAL,
    children: null,
    active: false,
  },
  {
    label: 'Dados Pessoais',
    path: '/dados-pessoais',
    icon: UserIcon,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'Perfil de Beleza',
    path: '/perfil-de-beleza',
    icon: Beauty,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'Programa de Influenciadores',
    path: '//glampartners.com.br',
    icon: Influencer,
    type: MENU_EXTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'MAG',
    path: '//glambox.com.br/mag',
    icon: Mag,
    type: MENU_EXTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'Glamshop',
    path: '//glamshop.com.br',
    icon: Bag,
    type: MENU_EXTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'Logout',
    path: '/logout',
    icon: Logout,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
];

const MenuPortal = [
  {
    label: 'Home',
    path: '/glampartner',
    icon: null,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
  {
    label: 'Glamstar',
    path: '/glampartner/glamstar',
    icon: null,
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Saiba mais',
        path: '/glampartner/glamstar/sobre',
        icon: About,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Challenges',
        path: '/glampartner/glamstar/desafios',
        icon: Star,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
    ],
    active: true,
  },
  {
    label: 'Atividades',
    path: '/glampartner/atividades',
    icon: null,
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Assinaturas',
        path: '/glampartner/assinaturas',
        icon: Glambox,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Produtos',
        path: '/glampartner/produtos',
        icon: CartIcon,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Publis',
        path: '/glampartner/publi',
        icon: HandshakeIcon,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
    ],
    active: true,
  },
  {
    label: 'Resultados',
    path: '/glampartner/resultados',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
  {
    label: 'Carreira',
    path: '/glampartner/carreira',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
    children: [
      {
        label: 'Plano de Desenvolvimento',
        path: '/glampartner/plano-de-desenvolvimento',
        icon: null,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Melhores posts',
        path: '/glampartner/melhore-seus-posts',
        icon: null,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
    ],
  },
  {
    label: 'Meus Dados',
    path: '/glampartner/meus-dados',
    icon: null,
    type: MENU_INTERNAL,
    children: [
      {
        label: 'Dados Pessoais',
        path: '/glampartner/dados-pessoais',
        icon: null,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Dados Para Pagamento',
        path: '/glampartner/dados-financeiros',
        icon: null,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
      {
        label: 'Redes Sociais',
        path: '/glampartner/redes-sociais',
        icon: null,
        type: MENU_INTERNAL,
        children: null,
        active: true,
      },
    ],
    active: true,
  },
  {
    label: 'Logout',
    path: '/logout',
    icon: null,
    type: MENU_INTERNAL,
    children: null,
    active: true,
  },
];

const MenuAdmin = [
  {
    label: 'Campanhas',
    path: '/admin/campaigns',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
    children: null,
  },
  {
    label: 'Problemas Campanhas',
    path: '/admin/campaigns/issues',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
  {
    label: 'Influencers',
    path: '/admin/influencers',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
  {
    label: 'Pagamentos',
    path: '/admin/payments',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
  {
    label: 'Dúvidas',
    path: '/admin/duvidas',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
  {
    label: 'Comissões',
    path: '/admin/comissions',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
  {
    label: 'GQ cupons',
    path: '/admin/glamqueen-coupon',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
  {
    label: 'Logout',
    path: '/logout',
    icon: null,
    type: MENU_INTERNAL,
    active: true,
  },
];

const generateMenu = (menuData, active = true, partner = false) => {
  if (Array.isArray(menuData)) {
    let menu = [...menuData];
    for (let item = 0; item < menu.length; item++) {
      switch (menu[item].path) {
        case '/comunidade':
          menu[item] = Object.assign(
            {},
            menu[item],
            partner === true ? Community.partner : Community.active
          );
          break;
        case '/glampartner':
          menu[item] = Object.assign(
            {},
            menu[item],
            partner === true
              ? (menu[item].active = true)
              : (menu[item].active = false)
          );
          break;
        case '/conteudo-exclusivo':
          menu[item] = Object.assign(
            {},
            menu[item],
            active === true
              ? ExclusiveContents.active
              : ExclusiveContents.inactive
          );
          break;
      }

      menu[item].children = generateMenu(menu[item].children, active, partner);
    }

    return menu;
  }

  return menuData;
};

const MenuActiveSubscriber = generateMenu(MenuBase, true, false);

const MenuInactiveSubscriber = generateMenu(MenuBase, false, false);

const MenuGlampartner = generateMenu(MenuBase, true, true);

export const MenuData = {
  MenuActiveSubscriber,
  MenuGlampartner,
  MenuInactiveSubscriber,
  MenuNonSubscriber,
  MenuPortal,
  MenuAdmin,
};
